import { z } from "zod";

export const RULE_BUNDLE_PAYLOAD_MAX_BYTES = 256 * 1024;
export const RULE_BUNDLE_SCHEMA_VERSION = 1;

const ruleTermSchema = z.string().trim().min(1).max(80);
export const ruleBundlePlatformSchema = z.enum(["ruten"]);

export const ruleBundleListingChecksSchema = z
  .object({
    maxTitleLength: z.number().int().min(1).max(120),
    requirePrice: z.boolean(),
    requireImage: z.boolean(),
    requireManualConfirmation: z.literal(true)
  })
  .strict();

export const ruleBundleRiskChecksSchema = z
  .object({
    forbiddenWords: z.array(ruleTermSchema).max(200),
    sensitiveClaims: z.array(ruleTermSchema).max(200),
    minImageCount: z.number().int().min(0).max(20)
  })
  .strict();

export const ruleBundlePayloadSchema = z
  .object({
    schemaVersion: z.literal(RULE_BUNDLE_SCHEMA_VERSION),
    platform: ruleBundlePlatformSchema,
    listingChecks: ruleBundleListingChecksSchema,
    riskChecks: ruleBundleRiskChecksSchema
  })
  .strict();

export const adminRuleBundlePublishSchema = z.object({
  bundleVersion: z.string().trim().min(1).max(120),
  expiresAt: z.string().trim().min(1),
  payload: ruleBundlePayloadSchema
});

export type AdminRuleBundlePublishInput = z.infer<
  typeof adminRuleBundlePublishSchema
>;

export type RuleBundlePayload = z.infer<typeof ruleBundlePayloadSchema>;
export type RuleBundleListingChecks = z.infer<typeof ruleBundleListingChecksSchema>;
export type RuleBundleRiskChecks = z.infer<typeof ruleBundleRiskChecksSchema>;
export type RuleBundlePlatform = z.infer<typeof ruleBundlePlatformSchema>;

export interface RuleBundle {
  bundleVersion: string;
  expiresAt: string;
  payload: RuleBundlePayload;
  signature: string;
}

export interface RuleBundleDraftInput {
  bundleVersion: string;
  expiresAt: string;
  payload: RuleBundlePayload;
}

export interface AdminRuleBundleView {
  publicKey: string;
  source: "published" | "none";
  bundleVersion: string | null;
  expiresAt: string | null;
  platform: RuleBundlePlatform;
  publishedAt: string | null;
  publishedByAdminId: string | null;
  bundle: RuleBundle | null;
}
